import { createFileRoute, redirect } from '@tanstack/react-router'
import { getPreferredLang } from '@/hooks/useLang'

export const Route = createFileRoute('/tools/country-codes')({
  beforeLoad: async () => {
    throw redirect({
      to: '/$lang/tools/country-codes',
      params: { lang: await getPreferredLang() },
      replace: true,
    })
  },
})
